import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@/components/feedback/loading-screen';
import PermissionGuard from '@/auth/guard/permission-guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';

// Lazy load components
const ActivitiesPage = lazy(() => import('@/pages/account/activities-page'));
const ActivitiesSummaryPage = lazy(() => import('@/pages/account/activities-summary-page'));

export const activitiesRoutes = [
  {
    path: 'activities',
    element: (
      <PermissionGuard
        module={OrionModule.ACCOUNT}
        submodule={OrionSubmodule.ACCOUNT.OPPORTUNITY}
        access={OrionAccess.VIEW}
        hasContent
      >
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </PermissionGuard>
    ),
    children: [
      {
        path: '',
        element: <ActivitiesPage />,
      },
      {
        path: 'summary',
        element: <ActivitiesSummaryPage />,
      },
    ],
  },
];
